export const lengthValues = {
	rem: 'rem',
	em: 'em',
	cm: 'cm',
	mm: 'mm',
	in: 'in',
	px: 'px',
	pt: 'pt',
	pc: 'pc',
	'%': '%',
};

export const timeValues = {
	s: 's',
	ms: 'ms',
};

export const fieldValues = {
	fontSize: {
		units: { ...lengthValues },
		nonUnits: [
			'medium',
			'xx-small',
			'x-small',
			'small',
			'large',
			'x-large',
			'xx-large',
			'smaller',
			'larger',
			'initial',
			'inherit',
		],
		default: 'px',
	},
	lineHeight: {
		units: { ...lengthValues, none: '' },
		nonUnits: ['normal', 'initial', 'inherit'],
		default: '',
	},
	letterSpacing: {
		units: { ...lengthValues },
		nonUnits: ['normal', 'initial', 'inherit'],
		default: 'px',
	},
	duration: {
		units: { ...timeValues },
		default: 's',
	},
	delay: {
		units: { ...timeValues },
		default: 's',
	},
	left: {
		units: { ...lengthValues },
		nonUnits: ['auto'],
		default: 'px',
	},
	top: {
		units: { ...lengthValues },
		nonUnits: ['auto'],
		default: 'px',
	},
	right: {
		units: { ...lengthValues },
		nonUnits: ['auto'],
		default: 'px',
	},
	bottom: {
		units: { ...lengthValues },
		nonUnits: ['auto'],
		default: 'px',
	},
	x: {
		units: { px: 'px' },
		default: 'px',
	},
	y: {
		units: { px: 'px' },
		default: 'px',
	},
	rotation: {
		units: { deg: 'deg' },
		default: 'deg',
	},
	scale: {
		units: {},
		default: '',
	},
	scaleX: {
		units: {},
		default: '',
	},
	scaleY: {
		units: {},
		default: '',
	},
	opacity: {
		units: {},
		default: '',
	},

	default: {
		units: { ...lengthValues, none: '' },
		nonUnits: ['auto', 'none', 'normal', 'initial', 'inherit'],
		default: '',
	},
};
